export default __webpack_public_path__ + "static/char-v-38-zh-Hant-0dc61fcc2ff8c19154a693e2da7c78d1.mp4";